"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDER = exports.TierGroup = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var Tier = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Tier"));

var MARKETING = 'marketing';
var SALES = 'sales';
var SERVICE = 'service';
var CMS = 'cms';

var TierGroup = _immutable.default.Record({
  key: '',
  tiers: _immutable.default.OrderedSet()
});

exports.TierGroup = TierGroup;

var ORDER = _immutable.default.OrderedSet([Tier.HUBSPOT_FREE, TierGroup({
  key: MARKETING,
  tiers: _immutable.default.OrderedSet([Tier.MARKETING_STARTER, Tier.MARKETING_PROFESSIONAL, Tier.MARKETING_ENTERPRISE])
}), TierGroup({
  key: SALES,
  tiers: _immutable.default.OrderedSet([Tier.SALES_STARTER, Tier.SALES_PROFESSIONAL, Tier.SALES_ENTERPRISE])
}), TierGroup({
  key: SERVICE,
  tiers: _immutable.default.OrderedSet([Tier.SERVICE_STARTER, Tier.SERVICE_PROFESSIONAL, Tier.SERVICE_ENTERPRISE])
}), TierGroup({
  key: CMS,
  tiers: _immutable.default.OrderedSet([Tier.CMS_STANDALONE, Tier.CMS_ENTERPRISE])
})]);

exports.ORDER = ORDER;


//////////////////
// WEBPACK FOOTER
// ./js/constants/tiers.js
// module id = 365
// module chunks = 209 210 211 212